import { Suspense, lazy } from 'react'
import LoadingView from '../../components/LoadingView'
import UrgeReload from '../../components/UrgeReload'

// FEATURE_DESKTOP_HANDOFF が false のビルドではルートごと消えるので、未使用の lazy としてチャンクごと外れるよう pure 指定する
const DesktopHandoff = /* @__PURE__ */ lazy(() => import('./DesktopHandoff').catch(() => ({default: UrgeReload})))

// AuthRedirect 配下で Suspense を持つのは GlobalLayout だけなので、ここで受ける
const LazyDesktopHandoff: React.FC = () =>
  <Suspense fallback={<LoadingView/>}>
    <DesktopHandoff/>
  </Suspense>

export default LazyDesktopHandoff
